<template>
  <div>
    <div class="forunInfo" v-if="!eventId">
      <div class="title">
        <span>当前位置：&nbsp;</span>
        <span>展会</span>
        <span>></span>
        <span>会议论坛</span>
        <span style="margin: 0 9px;">></span>
        <span>论坛资讯</span>
      </div>
      <div class="content">
        <ul>
          <li
            v-for="(item,index) in informationTypeList.slice( (pageIndex - 1 ) * pageSize, pageIndex * pageSize )"
            :key="index"
            @click="detail(item.id)"
          >
            <div class="leftDiv">
              <el-image :src="item.image && $getSrc(item.image)"></el-image>
            </div>
            <div class="centerDiv">
              <p>{{ item.title }}</p>
              <p>{{ item.introduce }}</p>
            </div>
            <div class="rightDiv">
              <p>{{ item.uploadDate ? item.uploadDate : item.createDate }}</p>
              <p>
                围观
                <span>{{ item.watchs }}</span>
                次
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          layout="prev, pager, next, slot"
          :page-size="pageSize"
          :total="totalPage"
        >
          <el-input type="text" v-model="pageNum"></el-input>
          <el-button class="tz" @click="pageTz">跳转</el-button>
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <!-- <fDetails
      v-else
      @setEventId="setEventId"
      @getInformationList="getInformationList"
      :eventId="eventId"
      :informationTypeList="informationTypeList"
    ></fDetails> -->
  </div>
</template>
<script>
// import fDetails from "./ForumDetails";
export default {
  components: {
    // fDetails,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 7,
      pageNum: 1,
      totalPage: 20,
      informationTypeList: [],
      eventId: null,
    };
  },
  mounted() {
    this.getInformationList();
  },
  methods: {
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum *= 1;
    },

    getInformationList() {
      this.$http({
        url: "getInformationList",
        method: "post",
        params: {
          type: "3",
        },
      }).then(({ data }) => {
        let { code, informationByTypeList } = data;
        this.totalPage = informationByTypeList.length;
        informationByTypeList.forEach((res) => {
          res.createDate = res.createDate.substring(0, 10);
          res.uploadDate = res.uploadDate ? res.uploadDate.substring(0, 10) : "";
        });
        this.informationTypeList = informationByTypeList;
      });
    },

    detail(id) {
      // this.eventId = id;
      this.$router.push({
        path: "/meeting/info/details",
        query: {
          id: id
        }
      })
    },

    setEventId() {
      this.eventId = null;
    },
  },
};
</script>
<style lang="scss">
.forunInfo {
  .btn-prev,
  .btn-next {
    width: 52px;
    height: 32px;
    color: #eeeeee;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
  .el-pager {
    height: 32px;
    .active {
      background-color: #17327e !important;
    }
    .number {
      height: 100%;
      width: 32px;
      line-height: 32px;
      &:hover {
        background-color: #17327e !important;
        color: #ffffff !important;
      }
    }
  }
  .btn-quicknext {
    height: 32px;
    line-height: 32px !important;
  }
  .el-pagination {
    .el-input {
      width: 32px;
      height: 32px;
      .el-input__inner {
        border-radius: 0;
        width: 32px;
        height: 32px;
        padding: 0;
      }
    }
    .el-button {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      color: #525252;
      margin-left: 8px;
      span {
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.forunInfo {
  min-height: 1177px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 11px;
    }
  }
  .content {
    width: 857px;
    min-height: 1043px;
    margin: 10px auto 21px;
    ul {
      li {
        height: 148px;
        cursor: pointer;
        // line-height: 148px;
        border-bottom: 1px solid #dfe1e1;
        .leftDiv {
          width: 140px;
          height: 88px;
          float: left;
          margin: 30px 22px 0 0;
          .el-image {
            width: 140px;
            height: 88px;
            .el-image__inner {
              width: 140px;
              height: 88px;
            }
          }
        }
        .centerDiv {
          width: 545px;
          height: 75px;
          float: left;
          margin-top: 36px;
          p:first-child {
            width: 545px;
            font-size: 18px;
            color: #333333;
            margin-bottom: 9px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p:last-child {
            font-size: 14px;
            color: #666666;
            line-height: 24px;
            text-indent: 37px;
            width: 545px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .rightDiv {
          height: 75px;
          float: right;
          font-size: 12px;
          color: #bbbbbb;
          margin-top: 40px;
          text-align: right;
          p:first-child {
            margin-bottom: 45px;
          }
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
  }
}
</style>